import { Amplify } from "aws-amplify";
import axios from "axios";

const config = {
  Auth: {
    Cognito: {
      region: process.env.NEXT_PUBLIC_AWS_REGION || "ap-south-1",
      userPoolId:
        process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || "ap-south-1_xbbswexe9",
      userPoolClientId:
        process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID ||
        "79dvibjvsp4kl9qs85a02rqre7",
      signUpVerificationMethod: "token",
      authenticationFlowType: "USER_SRP_AUTH",
      loginWith: {
        email: true,
        phone: false,
        username: false,
        oauth: {
          domain:
            process.env.NEXT_PUBLIC_COGNITO_DOMAIN ||
            "ap-south-1xbbswexe9.auth.ap-south-1.amazoncognito.com",
          scopes: ["email", "profile", "openid", "phone"],
          responseType: "token",
          redirectSignIn: [
            "https://paraacrypto.com/spot-trade",
            "https://www.paraacrypto.com/spot-trade",
            "https://paraacrypto.com",
            "https://www.paraacrypto.com",
            "https://ap-south-1xbbswexe9.auth.ap-south-1.amazoncognito.com",
            "https://ap-south-1xbbswexe9.auth.ap-south-1.amazoncognito.com/oauth2/idpresponse",
          ],
          redirectSignOut: [
            "https://paraacrypto.com",
            "https://www.paraacrypto.com",
            "https://paraacrypto.com/spot-trade",
            "https://www.paraacrypto.com/spot-trade",
            "https://ap-south-1xbbswexe9.auth.ap-south-1.amazoncognito.com",
            "https://ap-south-1xbbswexe9.auth.ap-south-1.amazoncognito.com/oauth2/idpresponse",
          ],
          providers: ["Google"],
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

// Initialize Amplify only on the client side
if (typeof window !== "undefined") {
  try {
    Amplify.configure(config);
  } catch (error) {
    console.error("Error configuring Amplify:", error);
  }
}
export default config;
